import { __ } from '@wordpress/i18n';

/**
 * Shared configuration for the project deadline datepicker, so "Modifica la
 * scadenza" and "Modifica il progetto" behave identically: the same validation
 * message and the same past dates greyed out in the calendar.
 */

const startOfToday = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
};

export const deadlineRules = {
    required: __('È obbligatorio', 'soundbetween'),
    validate: (value) => {
        if (!value) return true;

        return value > startOfToday() || __('La data deve essere nel futuro', 'soundbetween');
    }
};

export const disablePastDates = (date) => date <= startOfToday();
